import { makeRequest } from './data_utils';

const loadMeetings = () => {
    const endpoint = `api/instances`;
    return makeRequest(endpoint, 'GET');
};

const createInstance= (name, description, expectedDuration, level, instanceType, instanceReference, permissions, prompt_set_id) => {
    const endpoint = `api/instances`;
    const body = {
        name: name,
        description: description,  
        expectedDuration: expectedDuration,
        level: level,
        instanceType: instanceType,
        instanceReference: instanceReference,
        permissions: permissions,
        prompt_set_id: prompt_set_id
    };
    return makeRequest(endpoint, 'POST', body);
};

const updateInstance= (instanceId, name, description, expectedDuration, level, instanceType, instanceReference, permissions, prompt_set_id) => {
    const endpoint = `api/instances/${instanceId}`;
    const body = {
        name: name,
        description: description,  
        expectedDuration: expectedDuration,
        level: level,
        instanceType: instanceType,
        instanceReference: instanceReference,
        permissions: permissions,
        prompt_set_id: prompt_set_id
    };
    return makeRequest(endpoint, 'PUT', body);
};

const deleteInstance= (instanceId) => {
    const endpoint = `api/instances/${instanceId}`;
    return makeRequest(endpoint, 'DELETE');
};

const getInstance= (instanceId) => {
    const endpoint = `api/instances/${instanceId}`;
    return makeRequest(endpoint, 'GET');
};


const getCompletedMeeting = async (instanceId) => {
    try {
        const endpoint = `api/instances/${instanceId}/all-data`;
        const result = await makeRequest(endpoint, 'GET');
        
        if (!result.success || !result.data) {
            throw new Error('Failed to load meeting data');
        }


        
        // Format the response to match the expected structure
        const formattedData = {
            success: true,
            instance: {
                ...result.data.instance,
                training_id: result.data.instance.training_id  // ← ENSURE THIS IS INCLUDED
            },
            objectives: result.data.objectives || [],
            questions: result.data.questions || [],
            suggestions: result.data.suggestions || [],
            transcription: result.data.transcription ? {
                rawTranscription: result.data.transcription.rawTranscription || '',
                formattedTranscription: result.data.transcription.formattedTranscription || ''
            } : { rawTranscription: '', formattedTranscription: '' },
            actionItems: result.data.actionItems || [],
            wrapUp: result.data.wrapUp || [],
            participants: result.data.participants || [],
            timeline: result.data.timelines || result.data.timeline || null
        };

        // console.log('📋 FINAL FORMATTED DATA:', JSON.stringify(formattedData, null, 2));

        return formattedData;
    } catch (error) {
        console.error('Error in getCompletedMeeting:', error);
        return {
            success: false,
            message: error.message || 'Failed to load completed meeting'
        };
    }
};

const getInstanceLevels = () => {
    const endpoint = `api/instances/levels`;
    return makeRequest(endpoint, 'GET');
};

const getTemplates = () => {
    const endpoint = `api/instances/templates`;
    return makeRequest(endpoint, 'GET');
};

const getInstanceSharing = (instanceId) => {
    const endpoint = `api/instances/${instanceId}/sharing`;
    return makeRequest(endpoint, 'GET');
};

const addInstanceSharing = (instanceId, userIdToShare) => {
    const endpoint = `api/instances/${instanceId}/sharing`;
    const body = {
        userIdToShare: userIdToShare
    };
    return makeRequest(endpoint, 'POST', body);
};

const removeInstanceSharing = (instanceId, userIdToRemove) => {
    const endpoint = `api/instances/${instanceId}/sharing`;
    const body = {
        userIdToRemove: userIdToRemove
    };
    return makeRequest(endpoint, 'DELETE', body);
};

const changeInstancePermissions = (instanceId, permissions) => {
    const endpoint = `api/instances/${instanceId}/permissions`;
    const body = {
        permissions: permissions
    };
    return makeRequest(endpoint, 'PUT', body);
};

const resetInstanceData = (instanceId) => {
    const endpoint = `api/instances/${instanceId}/reset`;
    return makeRequest(endpoint, 'POST');
};

const setInstanceComplete = (short_id) => {
    const endpoint = `api/instances/${short_id}/set-completed`;
    return makeRequest(endpoint, 'PUT');
};

const cloneInstance = (instanceId, cloneName, cloneDescription) => {
    const endpoint = `api/instances/${instanceId}/clone`;
    const body = {
        name: cloneName,
        description: cloneDescription
    };
    return makeRequest(endpoint, 'POST', body);
};

const getMeetings = () => {
    const endpoint = `api/meetings`;
    return makeRequest(endpoint, 'GET');
};

const loadMeetingConclusion = async (meetingId, transcript, objectives) => {
    const endpoint = `api/meetings/${meetingId}/conclusion`;
    const body = {
        transcript,
        objectives
    };
    return makeRequest(endpoint, 'POST', body);
};



export const dataMeet = {
    loadMeetings,
    getMeetings,
    getInstance,
    createInstance,
    updateInstance,
    deleteInstance,
    getCompletedMeeting,
    getInstanceLevels,
    getTemplates,
    getInstanceSharing,
    addInstanceSharing,
    removeInstanceSharing,
    changeInstancePermissions,
    resetInstanceData,
    setInstanceComplete,
    cloneInstance,
    loadMeetingConclusion
};


